// src/components/dated-searches/dated-searches.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment DatedSearchesTitleFragment on LodgingHeader {\n    text\n    subText\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment DatedSearchesButtonsFragment on LodgingList {\n    title {\n      ...DatedSearchesTitleFragment\n    }\n    items {\n      label {\n        text\n      }\n      link {\n        text\n        icon {\n          id\n          description\n          token\n        }\n        action {\n          accessibility\n          analytics {\n            linkName\n            referrerId\n          }\n          resource {\n            value\n          }\n          target\n        }\n        size\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment DatedSearchesHorizontalFragment on LodgingList {\n    title {\n      ...DatedSearchesTitleFragment\n    }\n    items {\n      label {\n        text\n      }\n      link {\n        text\n        icon {\n          id\n          description\n          token\n        }\n        action {\n          accessibility\n          analytics {\n            linkName\n            referrerId\n          }\n          resource {\n            value\n          }\n          target\n        }\n        size\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextContentFragments on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...LodgingEGDSGraphicTextFragment\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment DatedSearchesCardFragment on LodgingListLineItem {\n    impressionAnalytics {\n      linkName\n      referrerId\n    }\n    label {\n      text\n      ... on EGDSSpannableText {\n        __typename\n        inlineContent {\n          ...LodgingEGDSGraphicTextFragment\n          ...EGDSStylizedTextFragment\n          ... on EGDSStandardLink {\n            text\n            action {\n              analytics {\n                referrerId\n              }\n              resource {\n                value\n              }\n            }\n          }\n        }\n      }\n    }\n    link {\n      ...EGDSStandardLinkFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment DatedSearchesLandingFragment on LodgingList {\n    title {\n      ...DatedSearchesTitleFragment\n      __typename\n    }\n    impressionAnalytics {\n      linkName\n      referrerId\n    }\n    items {\n      ...DatedSearchesCardFragment\n      __typename\n    }\n    __typename\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment DatedSearchesListFragment on LodgingList {\n    title {\n      ...DatedSearchesTitleFragment\n    }\n    items {\n      label {\n        text\n      }\n      link {\n        text\n        icon {\n          id\n          description\n          token\n        }\n        action {\n          accessibility\n          analytics {\n            linkName\n            referrerId\n          }\n          resource {\n            value\n          }\n          target\n        }\n        size\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment DatedSearchesRowFragment on LodgingList {\n    title {\n      ...DatedSearchesTitleFragment\n    }\n    items {\n      label {\n        text\n      }\n      link {\n        text\n        icon {\n          id\n          description\n          token\n        }\n        action {\n          accessibility\n          analytics {\n            linkName\n            referrerId\n          }\n          resource {\n            value\n          }\n          target\n        }\n        size\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  query DatedSearchesQuery(\n    $context: ContextInput!\n    $destination: DestinationInput!\n    $filters: PropertySearchFiltersInput!\n    $dataType: String!\n    $pageType: String!\n  ) {\n    lodgingDestination(context: $context, destination: $destination, filters: $filters) {\n      datedSearches(dataType: $dataType, pageType: $pageType) {\n        ...DatedSearchesListFragment\n        ...DatedSearchesRowFragment\n        ...DatedSearchesButtonsFragment\n        ...DatedSearchesHorizontalFragment\n        ...DatedSearchesLandingFragment\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment MapToolbarFragment on MapToolbar {\n    title\n    subtitle\n  }\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  query PropertySearchDynamicSearchMapQuery(\n    $context: ContextInput!\n    $destination: DestinationInput!\n    $rooms: [RoomInput!]\n    $dateRange: PropertyDateRangeInput\n    $sort: PropertySort\n    $filters: PropertySearchFiltersInput\n    $marketing: PropertyMarketingInfoInput\n    $propertyShopOptions: PropertyShopOptionsInput\n    $searchPagination: PaginationInput\n    $searchIntent: SearchIntentInput\n    $shoppingContext: ShoppingContextInput\n    $criteria: PropertySearchCriteriaInput\n    $productShoppingCriteriaInput: ProductShoppingCriteriaInput\n    $returnPropertyType: Boolean = true\n  ) {\n    propertySearch(\n      context: $context\n      destination: $destination\n      rooms: $rooms\n      dateRange: $dateRange\n      sort: $sort\n      filters: $filters\n      marketing: $marketing\n      propertyShopOptions: $propertyShopOptions\n      searchPagination: $searchPagination\n      searchIntent: $searchIntent\n      shoppingContext: $shoppingContext\n      criteria: $criteria\n      productShoppingCriteriaInput: $productShoppingCriteriaInput\n      returnPropertyType: $returnPropertyType\n    ) {\n      dynamicMap {\n        mapToolbar {\n          ...MapToolbarFragment\n        }\n        autoSearchOnMapMove {\n          ...LodgingEGDSCheckboxFragment\n        }\n        action {\n          ...LodgingEGDSFloatingButtonFragment\n        }\n        adaptExSuccessEvents {\n          ...LodgingAdaptExAnalyticsEventFragment\n        }\n        adaptExAttemptEvents {\n          ...LodgingAdaptExAnalyticsEventFragment\n        }\n        filterPlacement\n        map {\n          ...DynamicMapFragment\n        }\n      }\n      propertySearchListings {\n        ...LodgingCardFragment\n        ...PropertyOverfilteredCardFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(['\n  query MapConfigQuery($context: ContextInput!, $shoppingContext: ShoppingContextInput, $pageLocation: PageLocation!, $pageId: String = "srp") {\n    mapConfig(context: $context, shoppingContext: $shoppingContext, pageLocation: $pageLocation, pageId: $pageId) {\n      accessToken\n      egdsMapProvider\n      externalConfigEndpoint {\n        value\n      }\n      mapId\n    }\n  }\n']);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  query PropertySearchMapDialogTriggerQuery(\n    $context: ContextInput!\n    $destination: DestinationInput!\n    $shoppingContext: ShoppingContextInput\n    $criteria: PropertySearchCriteriaInput\n    $productShoppingCriteriaInput: ProductShoppingCriteriaInput\n    $returnPropertyType: Boolean = true\n  ) {\n    propertySearch(\n      context: $context\n      destination: $destination\n      shoppingContext: $shoppingContext\n      criteria: $criteria\n      productShoppingCriteriaInput: $productShoppingCriteriaInput\n      returnPropertyType: $returnPropertyType\n    ) {\n      mapTrigger {\n        ...MapTriggerFragment\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
import React9 from "react";
import { gql as gql9, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// src/components/dated-searches/__private/__fragments/dated-searches-buttons.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
// src/components/dated-searches/__private/__fragments/dated-searches-title.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSSubheading } from "@egds/react-core/text";
var __DatedSearchesTitleFragment = gql(_templateObject());
var DatedSearchesTitle = function (param) {
  var data = param.data,
    isCenterAligned = param.isCenterAligned;
  var text = data.text,
    subText = data.subText;
  return /* @__PURE__ */React.createElement(EGDSSpacing, {
    padding: "three"
  }, /* @__PURE__ */React.createElement("div", null, /* @__PURE__ */React.createElement(EGDSHeading, {
    tag: "h2",
    size: 5,
    align: isCenterAligned ? "center" : void 0
  }, text), /* @__PURE__ */React.createElement(EGDSSubheading, {
    tag: "h4",
    align: isCenterAligned ? "center" : void 0
  }, subText)));
};
DatedSearchesTitle.fragment = __DatedSearchesTitleFragment;
DatedSearchesTitle.displayName = "DatedSearchesTitle";
// src/components/dated-searches/__private/__fragments/dated-searches-buttons.tsx
var __DatedSearchesButtonsFragment = gql2(_templateObject1(), DatedSearchesTitle.fragment);
var DatedSearchesButtons = function (param) {
  var className = param.className,
    data = param.data;
  var clickTracker = useClickTracker();
  if (!data) {
    return null;
  }
  var items = data.items,
    title = data.title;
  return /* @__PURE__ */React2.createElement(EGDSCard, {
    className: className
  }, /* @__PURE__ */React2.createElement(DatedSearchesTitle, {
    data: title
  }), items.map(function (param, index) {
    var label = param.label,
      link = param.link;
    return link && label && /* @__PURE__ */React2.createElement(EGDSCard, {
      key: index
    }, /* @__PURE__ */React2.createElement(EGDSSpacing2, {
      margin: "two",
      padding: {
        inline: "two"
      },
      border: ["inlinestart", "inlineend", "blockstart", "blockend"]
    }, /* @__PURE__ */React2.createElement("div", null, /* @__PURE__ */React2.createElement(EGDSSpacing2, {
      padding: {
        block: "two"
      }
    }, /* @__PURE__ */React2.createElement(EGDSLink, {
      align: "center",
      analytics: {
        id: link.action.analytics.referrerId,
        description: link.action.analytics.linkName,
        callback: function (id, desc) {
          return clickTracker(id, desc);
        }
      }
    }, /* @__PURE__ */React2.createElement("a", {
      href: link.action.resource.value
    }, /* @__PURE__ */React2.createElement(EGDSIcon, {
      size: EGDSIconSize.SMALL,
      name: "today"
    }), /* @__PURE__ */React2.createElement(EGDSSpacing2, {
      margin: {
        inline: "two"
      }
    }, /* @__PURE__ */React2.createElement("div", null, label.text)), link.text))))));
  }));
};
DatedSearchesButtons.fragment = __DatedSearchesButtonsFragment;
DatedSearchesButtons.displayName = "DatedSearchesButtons";
// src/components/dated-searches/__private/__fragments/dated-searches-horizontal.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSCard as EGDSCard2 } from "@egds/react-core/cards";
import { EGDSLayoutFlex } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSText } from "@egds/react-core/text";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
var __DatedSearchesHorizontalFragment = gql3(_templateObject2(), DatedSearchesTitle.fragment);
var DatedSearchesHorizontal = function (param) {
  var className = param.className,
    data = param.data;
  var clickTracker = useClickTracker2();
  if (!data) {
    return null;
  }
  var items = data.items,
    title = data.title;
  return /* @__PURE__ */React3.createElement(EGDSLayoutGrid, {
    className: className,
    columns: 4,
    space: "two"
  }, /* @__PURE__ */React3.createElement(EGDSLayoutGridItem, {
    colSpan: 4
  }, /* @__PURE__ */React3.createElement("div", null, /* @__PURE__ */React3.createElement(DatedSearchesTitle, {
    data: title
  }))), items.length > 0 && items.map(function (param, index) {
    var label = param.label,
      link = param.link;
    return /* @__PURE__ */React3.createElement(EGDSLayoutGridItem, {
      colSpan: 1,
      key: index
    }, /* @__PURE__ */React3.createElement(EGDSCard2, null, /* @__PURE__ */React3.createElement(EGDSSpacing3, {
      padding: "four"
    }, /* @__PURE__ */React3.createElement(EGDSLayoutFlex, {
      direction: "column"
    }, link && /* @__PURE__ */React3.createElement(EGDSSpacing3, {
      padding: {
        block: "two"
      }
    }, /* @__PURE__ */React3.createElement(EGDSLink2, {
      align: "center",
      analytics: {
        id: link.action.analytics.referrerId,
        description: link.action.analytics.linkName,
        callback: function (id, desc) {
          return clickTracker(id, desc);
        }
      }
    }, /* @__PURE__ */React3.createElement("a", {
      href: link.action.resource.value
    }, link.text))), label && /* @__PURE__ */React3.createElement(EGDSText, {
      align: "center"
    }, label.text)))));
  }));
};
DatedSearchesHorizontal.fragment = __DatedSearchesHorizontalFragment;
DatedSearchesHorizontal.displayName = "DatedSearchesHorizontal";
// src/components/dated-searches/__private/__fragments/dated-searches-landing.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSCard as EGDSCard4 } from "@egds/react-core/cards";
import { EGDSCarousel } from "@egds/react-core/carousel";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge, ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
// src/components/dated-searches/__private/__fragments/dated-searches-card.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSCard as EGDSCard3 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink3 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { IntersectionTracker, useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { EGDSStandardLink, EGDSStylizedText as EGDSStylizedText2, LodgingEGDSGraphicText as LodgingEGDSGraphicText2 } from "@shared-ui/lodging-fragments";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
// src/components/dated-searches/__private/__fragments/dated-searches-spannable-text.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSStylizedText, LodgingEGDSGraphicText } from "@shared-ui/lodging-fragments";
var fragment = gql4(_templateObject3(), EGDSStylizedText.fragment, LodgingEGDSGraphicText.fragment);
var EGDSSpannableTextContents = function (param) {
  var data = param.data;
  switch (data.__typename) {
    case "EGDSStylizedText":
      return /* @__PURE__ */React4.createElement(EGDSSpacing4, {
        padding: {
          blockstart: "half"
        }
      }, /* @__PURE__ */React4.createElement(EGDSStylizedText, {
        data: data
      }));
    case "EGDSGraphicText":
      return /* @__PURE__ */React4.createElement(EGDSSpacing4, null, /* @__PURE__ */React4.createElement(LodgingEGDSGraphicText, {
        data: data,
        customPadding: {
          inlineend: "half",
          blockend: "two"
        }
      }));
    default:
      return null;
  }
};
EGDSSpannableTextContents.fragment = fragment;
EGDSSpannableTextContents.displayName = "EGDSSpannableTextContent";
// src/components/dated-searches/__private/__fragments/dated-searches-card.tsx
var __DatedSearchesCardFragment = gql5(_templateObject4(), LodgingEGDSGraphicText2.fragment, EGDSStylizedText2.fragment, EGDSStandardLink.fragment);
var DatedSearchesCard = function (param) {
  var data = param.data;
  var _link_action_analytics, _link_action, _link_action_analytics1, _link_action1;
  var trackClick = useClickTracker3();
  var impressionAnalytics = data.impressionAnalytics,
    label = data.label,
    link = data.link;
  var fetchValue = function (typeName) {
    var filteredData = (label === null || label === void 0 ? void 0 : label.__typename) === "EGDSSpannableText" && label.inlineContent ? label.inlineContent.find(function (item) {
      return (item === null || item === void 0 ? void 0 : item.__typename) === typeName;
    }) : null;
    if ((filteredData === null || filteredData === void 0 ? void 0 : filteredData.__typename) === "EGDSGraphicText" || (filteredData === null || filteredData === void 0 ? void 0 : filteredData.__typename) === "EGDSStylizedText") {
      return /* @__PURE__ */React5.createElement(EGDSSpannableTextContents, {
        data: filteredData
      });
    }
    if ((filteredData === null || filteredData === void 0 ? void 0 : filteredData.__typename) === "EGDSStandardLink") {
      return filteredData.text;
    }
  };
  var handleOnClick = function () {
    if (link) {
      window.location.href = link.action.resource.value;
    }
  };
  var linkItem = /* @__PURE__ */React5.createElement(EGDSLayoutFlex2, {
    justifyContent: "center"
  }, link && /* @__PURE__ */React5.createElement(EGDSLink3, {
    align: "center",
    analytics: {
      id: (_link_action = link.action) === null || _link_action === void 0 ? void 0 : (_link_action_analytics = _link_action.analytics) === null || _link_action_analytics === void 0 ? void 0 : _link_action_analytics.referrerId,
      description: (_link_action1 = link.action) === null || _link_action1 === void 0 ? void 0 : (_link_action_analytics1 = _link_action1.analytics) === null || _link_action_analytics1 === void 0 ? void 0 : _link_action_analytics1.linkName,
      callback: function (id, desc) {
        return trackClick(id, desc);
      }
    }
  }, /* @__PURE__ */React5.createElement("a", {
    href: link.action.resource.value
  }, fetchValue("EGDSStandardLink"))));
  var searchCard = /* @__PURE__ */React5.createElement(EGDSCard3, {
    backgroundTheme: "secondary",
    style: {
      cursor: "pointer"
    },
    border: true
  }, /* @__PURE__ */React5.createElement(EGDSSpacing5, {
    padding: {
      block: "three"
    }
  }, /* @__PURE__ */React5.createElement(EGDSLayoutFlex2, {
    direction: "column",
    onClick: handleOnClick
  }, /* @__PURE__ */React5.createElement(EGDSLayoutFlexItem, {
    grow: 1
  }, /* @__PURE__ */React5.createElement(EGDSSpacing5, {
    padding: {
      inlinestart: "one",
      inlineend: "one"
    }
  }, /* @__PURE__ */React5.createElement(EGDSLayoutFlex2, {
    justifyContent: "center"
  }, fetchValue("EGDSGraphicText"), fetchValue("EGDSStylizedText")))), /* @__PURE__ */React5.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React5.createElement(Viewport, null, /* @__PURE__ */React5.createElement(ViewSmall, null, impressionAnalytics !== null ? /* @__PURE__ */React5.createElement(IntersectionTracker, {
    referrerId: impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId,
    linkName: impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName
  }, linkItem) : linkItem), /* @__PURE__ */React5.createElement(ViewMedium, null, linkItem))))));
  return searchCard;
};
DatedSearchesCard.fragment = __DatedSearchesCardFragment;
DatedSearchesCard.displayName = "DatedSearchesCard";
// src/components/dated-searches/__private/__fragments/dated-searches-landing.tsx
var __DatedSearchesLandingFragment = gql6(_templateObject5(), DatedSearchesTitle.fragment, DatedSearchesCard.fragment);
var DatedSearchesLanding = function (param) {
  var className = param.className,
    desktopView = param.desktopView,
    data = param.data;
  var _data_items;
  if (!(data === null || data === void 0 ? void 0 : (_data_items = data.items) === null || _data_items === void 0 ? void 0 : _data_items.length)) {
    return null;
  }
  var impressionAnalytics = data.impressionAnalytics,
    items = data.items,
    title = data.title;
  var availabilityCards = items.map(function (item, index) {
    return /* @__PURE__ */React6.createElement(DatedSearchesCard, {
      data: item,
      key: index
    });
  });
  var carouselItem = /* @__PURE__ */React6.createElement(EGDSCarousel, {
    buttonText: {
      prevButton: "Previous",
      nextButton: "Next"
    },
    itemsMaxHeight: true,
    itemsVisible: {
      sm: 2,
      md: 4,
      lg: 4
    },
    itemsGap: {
      sm: 10,
      md: 16,
      lg: 16
    },
    peekAmount: {
      sm: 18,
      md: 16,
      lg: 32
    },
    peek: true,
    hideNav: true
  }, availabilityCards);
  var desktopLayout = function () {
    switch (desktopView) {
      case "TILE" /* TILE */:
        {
          return /* @__PURE__ */React6.createElement(EGDSSpacing6, {
            padding: "three"
          }, /* @__PURE__ */React6.createElement("div", null, /* @__PURE__ */React6.createElement(DatedSearchesTitle, {
            data: title,
            isCenterAligned: true
          }), /* @__PURE__ */React6.createElement(EGDSLayoutGrid2, {
            className: className,
            alignItems: "stretch",
            columns: 2,
            space: "two"
          }, availabilityCards)));
        }
      case "HALF_SIZE" /* HALF_SIZE */:
        {
          return /* @__PURE__ */React6.createElement(EGDSSpacing6, {
            padding: "three"
          }, /* @__PURE__ */React6.createElement("div", null, /* @__PURE__ */React6.createElement(DatedSearchesTitle, {
            data: title,
            isCenterAligned: true
          }), /* @__PURE__ */React6.createElement(EGDSLayoutGrid2, {
            className: className,
            alignItems: "stretch",
            columns: items.length,
            space: "three"
          }, availabilityCards)));
        }
      default:
        return /* @__PURE__ */React6.createElement(EGDSSpacing6, {
          padding: "four"
        }, /* @__PURE__ */React6.createElement(EGDSLayoutGrid2, {
          className: className
        }, /* @__PURE__ */React6.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React6.createElement(EGDSLayoutFlex3, null, /* @__PURE__ */React6.createElement(EGDSLayoutFlexItem2, {
          maxWidth: "88x",
          alignSelf: "stretch"
        }, /* @__PURE__ */React6.createElement("div", null, /* @__PURE__ */React6.createElement(DatedSearchesTitle, {
          data: title
        }))), /* @__PURE__ */React6.createElement(EGDSLayoutFlexItem2, null, carouselItem)))));
    }
  };
  return /* @__PURE__ */React6.createElement(Viewport2, null, /* @__PURE__ */React6.createElement(ViewSmall2, null, /* @__PURE__ */React6.createElement(EGDSSpacing6, {
    padding: {
      block: "three",
      inlinestart: "two",
      inlineend: "two"
    }
  }, /* @__PURE__ */React6.createElement(EGDSCard4, {
    border: true
  }, /* @__PURE__ */React6.createElement(DatedSearchesTitle, {
    data: title
  }), /* @__PURE__ */React6.createElement(EGDSSpacing6, {
    margin: {
      blockstart: "three"
    }
  }, carouselItem)))), /* @__PURE__ */React6.createElement(ViewMedium2, null, /* @__PURE__ */React6.createElement(IntersectionTracker2, {
    referrerId: (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) || "",
    linkName: (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) || ""
  }, /* @__PURE__ */React6.createElement(EGDSSpacing6, {
    padding: {
      block: "three",
      inlinestart: "two",
      inlineend: "two"
    }
  }, /* @__PURE__ */React6.createElement(EGDSCard4, {
    border: true
  }, /* @__PURE__ */React6.createElement(DatedSearchesTitle, {
    data: title,
    isCenterAligned: true
  }), /* @__PURE__ */React6.createElement(EGDSSpacing6, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React6.createElement(EGDSLayoutGrid2, {
    className: className,
    alignItems: "stretch",
    columns: items.length,
    space: "three"
  }, availabilityCards)))))), /* @__PURE__ */React6.createElement(ViewLarge, null, /* @__PURE__ */React6.createElement(IntersectionTracker2, {
    referrerId: (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) || "",
    linkName: (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) || ""
  }, /* @__PURE__ */React6.createElement(EGDSCard4, {
    border: true
  }, desktopLayout()))));
};
DatedSearchesLanding.fragment = __DatedSearchesLandingFragment;
DatedSearchesLanding.displayName = "DatedSearchesLanding";
// src/components/dated-searches/__private/__fragments/dated-searches-list.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSCard as EGDSCard5 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink4 } from "@egds/react-core/link";
import { EGDSTable, EGDSTableBody, EGDSTableCell, EGDSTableCellBorder, EGDSTableRow } from "@egds/react-core/tables";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
var __DatedSearchesListFragment = gql7(_templateObject6(), DatedSearchesTitle.fragment);
var DatedSearchesList = function (param) {
  var className = param.className,
    data = param.data;
  var clickTracker = useClickTracker4();
  if (!data) {
    return null;
  }
  var items = data.items,
    title = data.title;
  return /* @__PURE__ */React7.createElement(EGDSCard5, {
    className: className,
    "data-stid": "dated-searches-list"
  }, /* @__PURE__ */React7.createElement(DatedSearchesTitle, {
    data: title
  }), items.length > 0 && /* @__PURE__ */React7.createElement(EGDSTable, null, /* @__PURE__ */React7.createElement(EGDSTableBody, null, items.map(function (param, index) {
    var label = param.label,
      link = param.link;
    return /* @__PURE__ */React7.createElement(EGDSTableRow, {
      key: index
    }, /* @__PURE__ */React7.createElement(EGDSTableCell, {
      align: {
        vertical: "bottom"
      },
      border: EGDSTableCellBorder.horizontal
    }, /* @__PURE__ */React7.createElement(EGDSLayoutFlex4, {
      justifyContent: "space-between"
    }, /* @__PURE__ */React7.createElement(EGDSLayoutFlexItem3, {
      shrink: 0
    }, /* @__PURE__ */React7.createElement(EGDSText2, null, label === null || label === void 0 ? void 0 : label.text)), link && /* @__PURE__ */React7.createElement(EGDSLayoutFlex4, null, /* @__PURE__ */React7.createElement(EGDSLink4, {
      align: "right",
      analytics: {
        id: link.action.analytics.referrerId,
        description: link.action.analytics.linkName,
        callback: function (id, desc) {
          return clickTracker(id, desc);
        }
      }
    }, /* @__PURE__ */React7.createElement("a", {
      href: link.action.resource.value
    }, link.text))))));
  }))));
};
DatedSearchesList.fragment = __DatedSearchesListFragment;
DatedSearchesList.displayName = "DatedSearchesList";
// src/components/dated-searches/__private/__fragments/dated-searches-row.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSCard as EGDSCard6, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem3 } from "@egds/react-core/layout-grid";
import { EGDSLink as EGDSLink5 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
var __DatedSearchesRowFragment = gql8(_templateObject7(), DatedSearchesTitle.fragment);
var DatedSearchesRow = function (param) {
  var className = param.className,
    data = param.data;
  var clickTracker = useClickTracker5();
  if (!data) {
    return null;
  }
  var items = data.items,
    title = data.title;
  return /* @__PURE__ */React8.createElement(EGDSCard6, {
    className: className
  }, /* @__PURE__ */React8.createElement(EGDSLayoutGrid3, {
    columns: 4
  }, /* @__PURE__ */React8.createElement(EGDSLayoutGridItem3, {
    colSpan: 4
  }, /* @__PURE__ */React8.createElement("div", null, /* @__PURE__ */React8.createElement(DatedSearchesTitle, {
    data: title
  }))), items.length > 0 && items.map(function (param, index) {
    var label = param.label,
      link = param.link;
    return /* @__PURE__ */React8.createElement(EGDSLayoutGridItem3, {
      colSpan: 1,
      key: index
    }, /* @__PURE__ */React8.createElement(EGDSCardContentSection, null, label && /* @__PURE__ */React8.createElement(EGDSText3, {
      weight: "bold",
      size: 300
    }, label.text), link && /* @__PURE__ */React8.createElement(EGDSSpacing7, {
      padding: {
        block: "two"
      }
    }, /* @__PURE__ */React8.createElement(EGDSLink5, {
      analytics: {
        id: link.action.analytics.referrerId,
        description: link.action.analytics.linkName,
        callback: function (id, desc) {
          return clickTracker(id, desc);
        }
      }
    }, /* @__PURE__ */React8.createElement("a", {
      href: link.action.resource.value
    }, link.text)))));
  })));
};
DatedSearchesRow.fragment = __DatedSearchesRowFragment;
DatedSearchesRow.displayName = "DatedSearchesRow";
// src/components/dated-searches/dated-searches.tsx
var __DatedSearchesQuery = gql9(_templateObject8(), DatedSearchesList.fragment, DatedSearchesRow.fragment, DatedSearchesButtons.fragment, DatedSearchesHorizontal.fragment, DatedSearchesLanding.fragment);
var DatedSearches = function (props) {
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    view = props.view,
    className = props.className,
    desktopView = props.desktopView;
  var context = useBexApi().context;
  var variables = _object_spread_props(_object_spread({}, inputs || {}), {
    context: context
  });
  var _useQuery = useQuery(__DatedSearchesQuery, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  if (loading || error || !data) {
    return null;
  }
  var datedSearches = data.lodgingDestination.datedSearches;
  switch (view) {
    case "ROW":
      return /* @__PURE__ */React9.createElement(DatedSearchesRow, {
        className: className,
        data: datedSearches
      });
    case "BUTTONS":
      return /* @__PURE__ */React9.createElement(DatedSearchesButtons, {
        className: className,
        data: datedSearches
      });
    case "HORIZONTAL":
      return /* @__PURE__ */React9.createElement(DatedSearchesHorizontal, {
        className: className,
        data: datedSearches
      });
    case "LANDING":
      return /* @__PURE__ */React9.createElement(DatedSearchesLanding, {
        className: className,
        data: datedSearches,
        desktopView: desktopView
      });
    default:
      return /* @__PURE__ */React9.createElement(DatedSearchesList, {
        className: className,
        data: datedSearches
      });
  }
};
DatedSearches.displayName = "sharedui-DatedSearches";
// src/components/dynamic-search-map/dynamic-search-map.tsx
import React12 from "react";
import { gql as gql11, useQuery as useQuery2 } from "@apollo/client";
import { EGDSCard as EGDSCard7, EGDSCardContentSection as EGDSCardContentSection2 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid4, EGDSLayoutGridItem as EGDSLayoutGridItem4 } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";
import { EGDSPageLoader } from "@egds/react-core/loader";
import { EGDSEGMapsQualifier } from "@egds/react-core/map";
import { EGDSScrollable } from "@egds/react-core/scrollable";
import { EGDSSheet } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { ITrackType, useClickstreamAnalytics, useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { Experiment, ExperimentControl, ExperimentVariant, useExperiment } from "@shared-ui/experiment-context";
import { AdaptExAnalyticsEventFragment, adaptToAdaptExSuccessEventSchema, clientSideAnalyticsFragment, LodgingCard as LodgingCard2, LodgingEGDSCheckbox, LodgingEGDSFloatingButton, LodgingEGDSIcon, lodgingUILinkActionFragment, PropertyOverfilteredCard } from "@shared-ui/lodging-fragments";
import { DynamicMap, filterFeatureObject, findPinnedFeature, findProductObject, isProductType } from "@shared-ui/retail-dynamic-map";
import { FloatingPlaceCard, PlaceCardSize } from "@shared-ui/retail-places-place-details";
import { useSignalSubscriber } from "@shared-ui/signal-events-context";
import { SaveItemSignals } from "@shared-ui/trips-save-item";
import { defaultViewSizes, useMediaQueries, ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
// src/utils/dynamic-search-map-utils.ts
import { UitkEGMapsQualifier } from "@egds/react-core/map";
function priceMarkersForHotelAndVacationRentalConfig() {
  var _obj, _obj1;
  return {
    markers: {
      product: {
        markerType: (_obj = {}, _define_property(_obj, UitkEGMapsQualifier.HOTEL, null), _define_property(_obj, UitkEGMapsQualifier.VACATION_RENTAL, null), _obj)
      },
      property: {
        markerType: (_obj1 = {}, _define_property(_obj1, UitkEGMapsQualifier.HOTEL, null), _define_property(_obj1, UitkEGMapsQualifier.VACATION_RENTAL, null), _obj1)
      }
    }
  };
}
function filterPlacementTopOverrideConfig(filterPlacement) {
  if (filterPlacement === "OVERLAY_TOP" /* OVERLAY_TOP */) {
    return {
      style: {
        ".gm-bundled-control": {
          marginTop: "75px !important"
        }
      }
    };
  }
  return {};
}
// src/components/dynamic-search-map/floating-lodging-card.tsx
import React10 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
import { LodgingCard, LodgingCardView } from "@shared-ui/lodging-fragments";
var FloatingLodgingCard = function (props) {
  var data = props.data,
    onClickCallback = props.onClickCallback,
    onCardDismiss = props.onCardDismiss,
    showDismissButton = props.showDismissButton;
  return data ? /* @__PURE__ */React10.createElement(EGDSSpacing8, {
    margin: {
      inline: "three",
      blockend: "two"
    }
  }, /* @__PURE__ */React10.createElement(EGDSLayoutPosition, {
    type: "absolute",
    tag: "div",
    position: {
      bottom: "one"
    },
    pointerEvents: "none",
    style: {
      width: "calc(100% - 1.5rem)"
    }
  }, /* @__PURE__ */React10.createElement(EGDSLayoutFlex5, {
    justifyContent: "center"
  }, /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem4, {
    grow: 1,
    maxWidth: "180x"
  }, /* @__PURE__ */React10.createElement("div", {
    style: {
      pointerEvents: "all"
    }
  }, /* @__PURE__ */React10.createElement(LodgingCard, {
    data: data,
    onClickCallback: onClickCallback,
    view: LodgingCardView.COMPACT_HORIZONTAL,
    headingOverflow: showDismissButton ? "truncate-2-lines" : "wrap",
    onCardDismiss: onCardDismiss,
    showDismissButton: showDismissButton,
    enableInlineLink: true,
    placement: "Map"
  })))))) : null;
};
FloatingLodgingCard.displayName = "sharedui-FloatingLodgingCard";
// src/components/dynamic-search-map/map-toolbar.tsx
import React11 from "react";
import { gql as gql10 } from "@apollo/client";
import { EGDSToolbar } from "@egds/react-core/toolbar";
var fragment2 = gql10(_templateObject9());
var MapToolbar = function (param) {
  var onClose = param.onClose,
    filterComponent = param.filterComponent,
    data = param.data;
  var title = data.title,
    subtitle = data.subtitle;
  var navigationContent;
  if (onClose) {
    navigationContent = {
      onClick: onClose,
      navType: "close",
      navIconLabel: "close"
    };
  }
  return /* @__PURE__ */React11.createElement(EGDSToolbar, {
    navigationContent: navigationContent,
    toolbarTitle: title || "",
    toolbarSubtitle: subtitle,
    toolbarActionContent: filterComponent
  });
};
MapToolbar.displayName = "MapToolbar";
MapToolbar.fragment = fragment2;
// src/components/dynamic-search-map/dynamic-search-map.tsx
import { merge } from "merge-anything";
var __Query = gql11(_templateObject10(), AdaptExAnalyticsEventFragment, clientSideAnalyticsFragment, LodgingEGDSIcon.fragment, clientSideAnalyticsFragment, lodgingUILinkActionFragment, LodgingEGDSFloatingButton.fragment, LodgingEGDSCheckbox.fragment, DynamicMap.fragment, LodgingCard2.fragment, MapToolbar.fragment, PropertyOverfilteredCard.fragment);
var __MapConfigQuery = gql11(_templateObject11());
var triggerCanSearchId = "triggerCanSearchId";
var showCardId = "showCardId";
var DynamicSearchMap = function (_param) {
  var children = _param.children,
    props = _object_without_properties(_param, ["children"]);
  var _data_propertySearch, _data_propertySearch1, _propertySearchListingsData_filter;
  var batchKey = props.batchKey,
    inputs = props.inputs,
    fullscreenOptions = props.fullscreenOptions,
    onInit = props.onInit,
    beforeInit = props.beforeInit,
    onDestinationChanged = props.onDestinationChanged,
    onViewportChanged = props.onViewportChanged,
    onLodgingCardDisplayCallback = props.onLodgingCardDisplayCallback,
    onLodgingCardClickCallback = props.onLodgingCardClickCallback,
    initialViewport = props.initialViewport,
    pageId = props.pageId,
    _props_egMapsConfig = props.egMapsConfig,
    egMapsConfig = _props_egMapsConfig === void 0 ? {} : _props_egMapsConfig,
    clientPadding = props.clientPadding,
    height = props.height,
    filterComponent = props.filterComponent,
    skipSsr = props.skipSsr,
    _props_skipQuery = props.skipQuery,
    skipQuery = _props_skipQuery === void 0 ? false : _props_skipQuery,
    _props_skipMapConfigQuery = props.skipMapConfigQuery,
    skipMapConfigQuery = _props_skipMapConfigQuery === void 0 ? false : _props_skipMapConfigQuery,
    fetchPolicy = props.fetchPolicy,
    className = props.className,
    selectedFeatureId = props.selectedFeatureId,
    propertySearchResult = props.propertySearchResult,
    _props_hideOverfilteredToast = props.hideOverfilteredToast,
    hideOverfilteredToast = _props_hideOverfilteredToast === void 0 ? false : _props_hideOverfilteredToast,
    isPropertyListingLoading = props.isPropertyListingLoading,
    _props_showToolbar = props.showToolbar,
    showToolbar = _props_showToolbar === void 0 ? true : _props_showToolbar;
  var hasPropertySearchResult = Boolean(propertySearchResult);
  var context = useBexApi2().context;
  var mapRef = React12.useRef();
  var _React12_useState = _sliced_to_array(React12.useState(false), 2),
    initDone = _React12_useState[0],
    setInitDone = _React12_useState[1];
  var _React12_useState1 = _sliced_to_array(React12.useState(false), 2),
    viewportChanged = _React12_useState1[0],
    setViewportChanged = _React12_useState1[1];
  var autoSearch = React12.useRef();
  var _React12_useState2 = _sliced_to_array(React12.useState(void 0), 2),
    searchTriggeredFromDestination = _React12_useState2[0],
    setSearchTriggeredFromDestination = _React12_useState2[1];
  var _React12_useState3 = _sliced_to_array(React12.useState(true), 2),
    showLoading = _React12_useState3[0],
    setShowLoading = _React12_useState3[1];
  var _React12_useState4 = _sliced_to_array(React12.useState(), 2),
    selectedPropertyData = _React12_useState4[0],
    setSelectedPropertyData = _React12_useState4[1];
  var _React12_useState5 = _sliced_to_array(React12.useState(false), 2),
    showDismissButton = _React12_useState5[0],
    setShowDismissButton = _React12_useState5[1];
  var isSmallViewSize = useMediaQueries({
    viewSizes: defaultViewSizes
  }) === defaultViewSizes.SMALL;
  var _React12_useState6 = _sliced_to_array(React12.useState(), 2),
    selectedPlace = _React12_useState6[0],
    setSelectedPlace = _React12_useState6[1];
  var _React12_useState7 = _sliced_to_array(React12.useState(false), 2),
    propertySearchResultJustLoaded = _React12_useState7[0],
    setPropertySearchResultJustLoaded = _React12_useState7[1];
  var _React12_useState8 = _sliced_to_array(React12.useState(false), 2),
    preloadedTA = _React12_useState8[0],
    setPreloadedTA = _React12_useState8[1];
  var _useClickstreamAnalytics = useClickstreamAnalytics(),
    clickStreamTrack = _useClickstreamAnalytics.track;
  var trackClick = useClickTracker6();
  var _useExperiment = useExperiment("Quick_Filters_xLOB_Lodging_mWeb_Retest"),
    quickFiltersXlobLodgingMwebExposure = _useExperiment.exposure;
  var isQuickFiltersXlobLodgingMweb = quickFiltersXlobLodgingMwebExposure.bucket === 1;
  var variables = React12.useMemo(function () {
    return _object_spread_props(_object_spread({}, inputs), {
      context: context
    });
  }, [inputs, context]);
  var mapConfigVariables = React12.useMemo(function () {
    return {
      context: context,
      shoppingContext: {
        multiItem: null
      },
      pageLocation: "SEARCH_RESULTS" /* SEARCH_RESULTS */,
      pageId: pageId
    };
  }, [pageId, context]);
  var internalOnClose = React12.useCallback(function () {
    if (fullscreenOptions === null || fullscreenOptions === void 0 ? void 0 : fullscreenOptions.onClose) {
      fullscreenOptions.onClose();
    }
  }, [fullscreenOptions]);
  var findLodgingCardData = function (featureId) {
    if (featureId) {
      return propertySearchListingsData.find(function (d) {
        return d.__typename === "LodgingCard" && d.id === featureId;
      });
    }
    return void 0;
  };
  var selectPropertyCard = React12.useCallback(function (featureId) {
    if (featureId) {
      setSelectedPlace(void 0);
    }
    setShowDismissButton(true);
    var lodgingCardData = findLodgingCardData(featureId);
    setSelectedPropertyData(lodgingCardData);
    if (onLodgingCardDisplayCallback) {
      onLodgingCardDisplayCallback(lodgingCardData === null || lodgingCardData === void 0 ? void 0 : lodgingCardData.id);
    }
  }, [onLodgingCardDisplayCallback, findLodgingCardData]);
  var clearSelectedProperty = React12.useCallback(function () {
    var _mapRef_current, _mapRef_current1;
    (_mapRef_current = mapRef.current) === null || _mapRef_current === void 0 ? void 0 : _mapRef_current.clearSelectedFeature();
    (_mapRef_current1 = mapRef.current) === null || _mapRef_current1 === void 0 ? void 0 : _mapRef_current1.dehighlightFeatures();
    selectPropertyCard();
    if (preloadedTA) {
      trackClick("HOT.SRP.Module.Map.PreloadedHotelCard.Closed", "Hotel card closed on SRP Map", false);
    }
    setPreloadedTA(false);
    trackClick("HOT.SR.Module.Map.HotelCard.Closed", "Hotel card closed on SRP Map", false);
  }, [selectPropertyCard, preloadedTA]);
  var showCardOnMarkerSelection = React12.useCallback(function (event) {
    var selectMarker = function (markerFeature) {
      if (isProductType(markerFeature.type)) {
        var _mapRef_current;
        setSelectedPlace(void 0);
        (_mapRef_current = mapRef.current) === null || _mapRef_current === void 0 ? void 0 : _mapRef_current.dehighlightFeatures();
        selectPropertyCard(markerFeature.id);
      } else if (markerFeature.type === "place") {
        selectPropertyCard();
        setSelectedPlace(markerFeature);
      }
    };
    var feature = event.feature,
      action2 = event.action;
    switch (action2) {
      case "select":
        selectMarker(feature);
        break;
      case "clearSelection":
        selectPropertyCard();
        setSelectedPlace(void 0);
        trackClick("HOT.SR.Module.Map.HotelCard.ClosedByMapClick", "Hotel card closed on HSR Map by map click", false);
        break;
      default:
        selectPropertyCard();
        setSelectedPlace(void 0);
        break;
    }
  }, [selectPropertyCard]);
  var clearPlaceCardId = React12.useCallback(function () {
    var _mapRef_current;
    setSelectedPropertyData(void 0);
    setSelectedPlace(void 0);
    (_mapRef_current = mapRef.current) === null || _mapRef_current === void 0 ? void 0 : _mapRef_current.clearSelectedFeature();
  }, [selectedPlace === null || selectedPlace === void 0 ? void 0 : selectedPlace.id]);
  var mapConfigQueryOptions = _object_spread({
    variables: mapConfigVariables,
    skip: skipQuery || skipMapConfigQuery
  }, fetchPolicy ? {
    fetchPolicy: fetchPolicy
  } : {});
  var _useQuery2 = useQuery2(__MapConfigQuery, mapConfigQueryOptions),
    mapConfigData = _useQuery2.data;
  var queryOptions = _object_spread({
    context: {
      batchKey: batchKey
    },
    variables: variables,
    ssr: !skipSsr,
    skip: skipQuery || hasPropertySearchResult,
    notifyOnNetworkStatusChange: true
  }, fetchPolicy ? {
    fetchPolicy: fetchPolicy
  } : {});
  var _useQuery21 = useQuery2(__Query, queryOptions),
    currentData = _useQuery21.data,
    loading = _useQuery21.loading,
    error = _useQuery21.error,
    previousData = _useQuery21.previousData;
  var data = currentData !== null && currentData !== void 0 ? currentData : previousData;
  var dynamicMap = hasPropertySearchResult ? propertySearchResult === null || propertySearchResult === void 0 ? void 0 : propertySearchResult.dynamicMap : data === null || data === void 0 ? void 0 : (_data_propertySearch = data.propertySearch) === null || _data_propertySearch === void 0 ? void 0 : _data_propertySearch.dynamicMap;
  var _ref = dynamicMap || {},
    action = _ref.action,
    mapData = _ref.map,
    mapToolbar = _ref.mapToolbar,
    autoSearchOnMapMove = _ref.autoSearchOnMapMove,
    adaptExSuccessEvents = _ref.adaptExSuccessEvents,
    adaptExAttemptEvents = _ref.adaptExAttemptEvents,
    filterPlacement = _ref.filterPlacement;
  React12.useEffect(function () {
    if (mapRef.current) {
      mapRef.current.forceMapModeView();
    }
  }, [mapData]);
  var propertySearchListingsData = React12.useMemo(function () {
    var _propertySearchResult_propertySearchListings, _data_propertySearch;
    if ((propertySearchResult === null || propertySearchResult === void 0 ? void 0 : propertySearchResult.propertySearchListings) && (propertySearchResult === null || propertySearchResult === void 0 ? void 0 : (_propertySearchResult_propertySearchListings = propertySearchResult.propertySearchListings) === null || _propertySearchResult_propertySearchListings === void 0 ? void 0 : _propertySearchResult_propertySearchListings.length) > 0) {
      return propertySearchResult === null || propertySearchResult === void 0 ? void 0 : propertySearchResult.propertySearchListings;
    }
    return (data === null || data === void 0 ? void 0 : (_data_propertySearch = data.propertySearch) === null || _data_propertySearch === void 0 ? void 0 : _data_propertySearch.propertySearchListings) || [];
  }, [data === null || data === void 0 ? void 0 : (_data_propertySearch1 = data.propertySearch) === null || _data_propertySearch1 === void 0 ? void 0 : _data_propertySearch1.propertySearchListings, propertySearchResult === null || propertySearchResult === void 0 ? void 0 : propertySearchResult.propertySearchListings]);
  var overfilteredCardData = hideOverfilteredToast ? null : propertySearchListingsData === null || propertySearchListingsData === void 0 ? void 0 : (_propertySearchListingsData_filter = propertySearchListingsData.filter(function (card) {
    return card.__typename === "PropertySearchListingsOverfilteredCard";
  })) === null || _propertySearchListingsData_filter === void 0 ? void 0 : _propertySearchListingsData_filter[0];
  var dynamicMapConfig = React12.useMemo(function () {
    return merge(priceMarkersForHotelAndVacationRentalConfig(), filterPlacementTopOverrideConfig(filterPlacement), egMapsConfig);
  }, [egMapsConfig, filterPlacement]);
  React12.useEffect(function () {
    setPropertySearchResultJustLoaded(true);
  }, [propertySearchResult === null || propertySearchResult === void 0 ? void 0 : propertySearchResult.propertySearchListings]);
  React12.useEffect(function () {
    var wasLoading = showLoading;
    var searchInProgress = isPropertyListingLoading !== null && isPropertyListingLoading !== void 0 ? isPropertyListingLoading : loading;
    setShowLoading(searchInProgress);
    if (!searchInProgress && initDone) {
      if (wasLoading || propertySearchResultJustLoaded) {
        var map = mapRef.current;
        if (map) {
          var feature = map.getFeatureSelected();
          var _ref = feature ? [feature].filter(filterFeatureObject)[0] || {} : {},
            _ref_id = _ref.id,
            id = _ref_id === void 0 ? void 0 : _ref_id,
            _ref_type = _ref.type,
            type = _ref_type === void 0 ? void 0 : _ref_type;
          if (id && type && map.listFeatures(function (f) {
            return f.id === id && f.type === type;
          }).length > 0) {
            setSelectedPropertyData(findLodgingCardData(id));
          } else {
            map.clearSelectedFeature();
            setSelectedPropertyData(void 0);
          }
        }
      }
      if (searchTriggeredFromDestination) {
        setSearchTriggeredFromDestination(void 0);
        setViewportChanged(false);
      }
    }
    setPropertySearchResultJustLoaded(false);
  }, [loading, searchTriggeredFromDestination, setSearchTriggeredFromDestination, setShowLoading, data, propertySearchResultJustLoaded, isPropertyListingLoading]);
  React12.useEffect(function () {
    selectExternalFeatureId();
  }, [selectedFeatureId]);
  var getDestinationInput = React12.useCallback(function () {
    var _mapRef_current;
    var egMapsBounds = (_mapRef_current = mapRef.current) === null || _mapRef_current === void 0 ? void 0 : _mapRef_current.getBounds();
    if (egMapsBounds) {
      var _egMapsBounds_center_, _egMapsBounds_center_1, _egMapsBounds_sw_, _egMapsBounds_sw_1, _egMapsBounds_ne_, _egMapsBounds_ne_1;
      return {
        coordinates: {
          latitude: (_egMapsBounds_center_ = egMapsBounds.center[0]) !== null && _egMapsBounds_center_ !== void 0 ? _egMapsBounds_center_ : 0,
          longitude: (_egMapsBounds_center_1 = egMapsBounds.center[1]) !== null && _egMapsBounds_center_1 !== void 0 ? _egMapsBounds_center_1 : 0
        },
        mapBounds: [{
          latitude: (_egMapsBounds_sw_ = egMapsBounds.sw[0]) !== null && _egMapsBounds_sw_ !== void 0 ? _egMapsBounds_sw_ : 0,
          longitude: (_egMapsBounds_sw_1 = egMapsBounds.sw[1]) !== null && _egMapsBounds_sw_1 !== void 0 ? _egMapsBounds_sw_1 : 0
        }, {
          latitude: (_egMapsBounds_ne_ = egMapsBounds.ne[0]) !== null && _egMapsBounds_ne_ !== void 0 ? _egMapsBounds_ne_ : 0,
          longitude: (_egMapsBounds_ne_1 = egMapsBounds.ne[1]) !== null && _egMapsBounds_ne_1 !== void 0 ? _egMapsBounds_ne_1 : 0
        }]
      };
    }
  }, []);
  var destinationAsString = React12.useCallback(function (dest) {
    var _dest_mapBounds;
    return "".concat((_dest_mapBounds = dest.mapBounds) === null || _dest_mapBounds === void 0 ? void 0 : _dest_mapBounds.map(function (c) {
      return "".concat(c.latitude, ",").concat(c.longitude);
    }).join(";"));
  }, []);
  React12.useEffect(function () {
    var searchInProgress = isPropertyListingLoading !== null && isPropertyListingLoading !== void 0 ? isPropertyListingLoading : loading;
    setShowLoading(searchInProgress);
    if (!searchInProgress && searchTriggeredFromDestination) {
      var dest = getDestinationInput();
      if (!dest || destinationAsString(dest) === searchTriggeredFromDestination) {
        setSearchTriggeredFromDestination(void 0);
        setViewportChanged(false);
      }
    }
  }, [loading, searchTriggeredFromDestination, setSearchTriggeredFromDestination, setShowLoading, setViewportChanged, data, getDestinationInput, destinationAsString, isPropertyListingLoading]);
  React12.useEffect(function () {
    if (viewportChanged && onViewportChanged) {
      var dest = getDestinationInput();
      if (dest) {
        onViewportChanged(dest);
      }
    }
  }, [viewportChanged, onViewportChanged]);
  var updateSearch = React12.useCallback(function () {
    if (onDestinationChanged) {
      var dest = getDestinationInput();
      if (dest) {
        setSearchTriggeredFromDestination(destinationAsString(dest));
        onDestinationChanged(dest);
      }
    }
  }, [onDestinationChanged, getDestinationInput, destinationAsString]);
  var onAutoSearchChecked = React12.useCallback(function (event) {
    autoSearch.current = event.target.checked;
    if (autoSearch.current && viewportChanged) {
      updateSearch();
    }
  }, [updateSearch, viewportChanged]);
  var updateCanSearch = React12.useCallback(function () {
    setViewportChanged(true);
    if (autoSearch.current) {
      updateSearch();
    }
  }, [updateSearch]);
  var selectExternalFeatureId = React12.useCallback(function () {
    if (mapRef.current && initDone) {
      mapRef.current.dehighlightFeatures();
      if (selectedFeatureId) {
        var feature = findProductObject(mapRef.current, selectedFeatureId);
        if (feature) {
          mapRef.current.markFeatureOver(feature.id, feature.type);
          return true;
        }
      }
    }
    return false;
  }, [selectedFeatureId, initDone]);
  React12.useEffect(function () {
    if (mapRef.current) {
      mapRef.current.addBoundChangeListener(updateCanSearch, triggerCanSearchId);
    }
  }, [updateCanSearch]);
  React12.useEffect(function () {
    if (mapRef.current) {
      mapRef.current.addSelectionChangeListener(showCardOnMarkerSelection, showCardId);
    }
  }, [showCardOnMarkerSelection]);
  React12.useEffect(function () {
    if (adaptExAttemptEvents) {
      adaptExAttemptEvents.forEach(function (adaptExEvent) {
        var events = adaptExEvent.events[0];
        clickStreamTrack(ITrackType.EVENT, {
          data: adaptToAdaptExSuccessEventSchema(_object_spread_props(_object_spread({}, adaptExEvent), {
            events: events ? [events] : void 0
          }))
        });
      });
    }
  }, [adaptExAttemptEvents]);
  var internalOnInit = React12.useCallback(function (map) {
    mapRef.current = map;
    setInitDone(true);
    if (onInit) {
      onInit(map);
    }
  }, []);
  var internalBeforeInit = React12.useCallback(function (map) {
    map.addBoundChangeListener(updateCanSearch, triggerCanSearchId);
    map.addSelectionChangeListener(showCardOnMarkerSelection, showCardId);
    if (beforeInit) {
      beforeInit(map);
    }
  }, []);
  var internalLodgingCardClickCallback = React12.useCallback(function () {
    if (onLodgingCardClickCallback && selectedPropertyData) {
      onLodgingCardClickCallback(selectedPropertyData);
    }
    if (adaptExSuccessEvents) {
      adaptExSuccessEvents.forEach(function (adaptExEvent) {
        var events = adaptExEvent.events[0];
        clickStreamTrack(ITrackType.EVENT, {
          data: adaptToAdaptExSuccessEventSchema(_object_spread_props(_object_spread({}, adaptExEvent), {
            events: events ? [events] : void 0
          }))
        });
      });
    }
  }, [selectedPropertyData, adaptExSuccessEvents, onLodgingCardClickCallback]);
  var internalOnFeaturesPushed = React12.useCallback(function () {
    if (!selectExternalFeatureId() && mapRef.current) {
      var feature = findPinnedFeature(mapRef.current);
      if (feature) {
        var _mapRef_current;
        var id = feature.id,
          type = feature.type;
        (_mapRef_current = mapRef.current) === null || _mapRef_current === void 0 ? void 0 : _mapRef_current.markFeatureOver(id, type);
        selectPropertyCard("".concat(id));
        var preloadedTravelAd = propertySearchListingsData.find(function (property) {
          var _property_mediaSection_badges_secondaryBadge, _property_mediaSection_badges;
          return property.__typename === "LodgingCard" && property.id === id && ((_property_mediaSection_badges = property.mediaSection.badges) === null || _property_mediaSection_badges === void 0 ? void 0 : (_property_mediaSection_badges_secondaryBadge = _property_mediaSection_badges.secondaryBadge) === null || _property_mediaSection_badges_secondaryBadge === void 0 ? void 0 : _property_mediaSection_badges_secondaryBadge.theme) === "sponsored";
        });
        if (preloadedTravelAd) {
          setPreloadedTA(true);
        }
      }
    }
  }, [propertySearchListingsData]);
  var destinationIsBounds = React12.useMemo(function () {
    var _variables_destination_mapBounds, _variables_destination, _variables_criteria_primary_destination_mapBounds, _variables_criteria_primary_destination, _variables_criteria_primary, _variables_criteria;
    return (variables === null || variables === void 0 ? void 0 : (_variables_destination = variables.destination) === null || _variables_destination === void 0 ? void 0 : (_variables_destination_mapBounds = _variables_destination.mapBounds) === null || _variables_destination_mapBounds === void 0 ? void 0 : _variables_destination_mapBounds.length) === 2 || (variables === null || variables === void 0 ? void 0 : (_variables_criteria = variables.criteria) === null || _variables_criteria === void 0 ? void 0 : (_variables_criteria_primary = _variables_criteria.primary) === null || _variables_criteria_primary === void 0 ? void 0 : (_variables_criteria_primary_destination = _variables_criteria_primary.destination) === null || _variables_criteria_primary_destination === void 0 ? void 0 : (_variables_criteria_primary_destination_mapBounds = _variables_criteria_primary_destination.mapBounds) === null || _variables_criteria_primary_destination_mapBounds === void 0 ? void 0 : _variables_criteria_primary_destination_mapBounds.length) === 2;
  }, [variables]);
  var createPlaceCardDetailsFragment = function (feature) {
    return {
      id: feature.id.toString(),
      title: {
        text: feature.name ? feature.name : "",
        __typename: "EGDSPlainText"
      },
      subtitle: {
        text: feature.text ? feature.text : "",
        __typename: "EGDSPlainText"
      },
      description: null,
      footerText: null,
      media: null,
      closeAction: {
        __typename: "UITertiaryButton",
        accessibility: "Close",
        icon: {
          __typename: "Icon",
          description: "close",
          id: "close",
          token: "close"
        }
      },
      __typename: "PlaceCardDetails"
    };
  };
  var searchButton = action && viewportChanged && onDestinationChanged ? /* @__PURE__ */React12.createElement(EGDSLayoutPosition2, {
    type: "absolute",
    position: {
      top: "twelve",
      left: "center"
    },
    cloneElement: true
  }, filterPlacement === "OVERLAY_TOP" /* OVERLAY_TOP */ ? /* @__PURE__ */React12.createElement("div", null, /* @__PURE__ */React12.createElement(EGDSLayoutPosition2, {
    type: "relative",
    position: {
      top: isQuickFiltersXlobLodgingMweb ? "four" : "twelve"
    }
  }, /* @__PURE__ */React12.createElement(LodgingEGDSFloatingButton, {
    data: action,
    disabled: showLoading,
    onClick: updateSearch
  }))) : /* @__PURE__ */React12.createElement(LodgingEGDSFloatingButton, {
    data: action,
    disabled: showLoading,
    onClick: updateSearch
  })) : null;
  var autoSearchCheckbox = (autoSearchOnMapMove === null || autoSearchOnMapMove === void 0 ? void 0 : autoSearchOnMapMove.required) ? /* @__PURE__ */React12.createElement(EGDSLayoutPosition2, {
    type: "absolute",
    position: {
      top: "zero",
      right: "twelve",
      zindex: "layer1"
    }
  }, /* @__PURE__ */React12.createElement(EGDSSpacing9, {
    margin: "three"
  }, /* @__PURE__ */React12.createElement(EGDSCard7, {
    border: true
  }, /* @__PURE__ */React12.createElement(EGDSCardContentSection2, {
    padded: ["inlinestart", "inlineend"]
  }, /* @__PURE__ */React12.createElement("div", null, /* @__PURE__ */React12.createElement(LodgingEGDSCheckbox, {
    data: autoSearchOnMapMove,
    onChange: onAutoSearchChecked,
    checked: autoSearch.current,
    tabIndex: 0
  })))))) : null;
  React12.useEffect(function () {
    if (!autoSearch.current && autoSearchOnMapMove && autoSearchOnMapMove.state === "CHECKED" /* CHECKED */) {
      autoSearch.current = true;
    }
  }, [autoSearchOnMapMove]);
  var loadingSpinner = showLoading && !error ? /* @__PURE__ */React12.createElement(EGDSLayoutPosition2, {
    type: "absolute",
    style: {
      height: "100%",
      width: "100%"
    },
    pointerEvents: "none"
  }, /* @__PURE__ */React12.createElement(EGDSLayoutPosition2, {
    "aria-label": "loading-spinner",
    type: "absolute",
    position: {
      top: "center",
      left: "center"
    }
  }, /* @__PURE__ */React12.createElement(EGDSPageLoader, {
    visible: true
  }))) : null;
  var overTopFilter = filterPlacement === "OVERLAY_TOP" /* OVERLAY_TOP */ &&
  // setting absolute element to be scrollable on an absolute layout is tricky without custom CSS
  /* @__PURE__ */
  React12.createElement(EGDSLayoutPosition2, {
    type: "absolute",
    position: _object_spread({
      top: "two",
      left: "zero"
    }, isQuickFiltersXlobLodgingMweb && {
      top: "one",
      right: "zero"
    }),
    cloneElement: true
  }, /* @__PURE__ */React12.createElement("div", null, /* @__PURE__ */React12.createElement(EGDSLayoutPosition2, {
    type: "relative"
  }, /* @__PURE__ */React12.createElement(EGDSLayoutGrid4, null, /* @__PURE__ */React12.createElement(EGDSLayoutGridItem4, null, /* @__PURE__ */React12.createElement("div", null, isQuickFiltersXlobLodgingMweb ?
  // These are styling changes to have the filter bar carousel render in map view, removal of the EGDSScrollable & EGDSSpacing component to fix spacing around the filter bar
  // These changes are put behind the TNL 50317
  filterComponent : /* @__PURE__ */React12.createElement(EGDSScrollable, {
    direction: "horizontal"
  }, /* @__PURE__ */React12.createElement(EGDSSpacing9, {
    padding: {
      block: "two",
      inlinestart: "two",
      inlineend: isSmallViewSize ? void 0 : "two"
    }
  }, filterComponent))))))));
  var updateSavedQualifier = function (tripItemId, toggleState) {
    if (tripItemId !== void 0 && mapRef.current) {
      var feature = findProductObject(mapRef.current, tripItemId);
      if (feature) {
        if (toggleState) {
          var _mapRef_current;
          (_mapRef_current = mapRef.current) === null || _mapRef_current === void 0 ? void 0 : _mapRef_current.addQualifierToFeature(feature.id, feature.type, EGDSEGMapsQualifier.SAVED);
        } else {
          var _mapRef_current1;
          (_mapRef_current1 = mapRef.current) === null || _mapRef_current1 === void 0 ? void 0 : _mapRef_current1.removeQualifierFromFeature(feature.id, feature.type, EGDSEGMapsQualifier.SAVED);
        }
      }
    }
  };
  useSignalSubscriber({
    query: {
      type: SaveItemSignals.TRIP_ITEM_SAVED
    },
    onSignal: function (event) {
      var _event_payload, _event_payload1;
      return updateSavedQualifier(event === null || event === void 0 ? void 0 : (_event_payload = event.payload) === null || _event_payload === void 0 ? void 0 : _event_payload.tripItemId, (_event_payload1 = event.payload) === null || _event_payload1 === void 0 ? void 0 : _event_payload1.toggleState);
    }
  });
  useSignalSubscriber({
    query: {
      type: SaveItemSignals.TRIP_ITEM_UNSAVED
    },
    onSignal: function (event) {
      var _event_payload, _event_payload1;
      return updateSavedQualifier(event === null || event === void 0 ? void 0 : (_event_payload = event.payload) === null || _event_payload === void 0 ? void 0 : _event_payload.tripItemId, (_event_payload1 = event.payload) === null || _event_payload1 === void 0 ? void 0 : _event_payload1.toggleState);
    }
  });
  var overfilteredCard = overfilteredCardData && /* @__PURE__ */React12.createElement(PropertyOverfilteredCard, {
    data: overfilteredCardData,
    isPropertySelected: Boolean(selectedPropertyData)
  });
  var content = mapRef.current || !error ? /* @__PURE__ */React12.createElement(EGDSLayoutPosition2, {
    type: "relative",
    style: {
      height: "100%"
    }
  }, autoSearchCheckbox, /* @__PURE__ */React12.createElement(DynamicMap, {
    className: className,
    data: mapData,
    onInit: internalOnInit,
    beforeInit: internalBeforeInit,
    initialViewport: initialViewport,
    initialMapConfig: mapConfigData === null || mapConfigData === void 0 ? void 0 : mapConfigData.mapConfig,
    egMapsConfig: dynamicMapConfig,
    clientPadding: clientPadding,
    height: height,
    updateViewport: !destinationIsBounds,
    onFeaturesPushed: internalOnFeaturesPushed
  }, overTopFilter, searchButton, loadingSpinner, overfilteredCard, /* @__PURE__ */React12.createElement(FloatingLodgingCard, {
    data: selectedPropertyData,
    onClickCallback: internalLodgingCardClickCallback,
    onCardDismiss: clearSelectedProperty,
    showDismissButton: showDismissButton
  }), /* @__PURE__ */React12.createElement(Experiment, {
    name: "Display_Tile_Server_Content_on_SRP_Map"
  }, /* @__PURE__ */React12.createElement(ExperimentVariant, {
    bucket: 1
  }, /* @__PURE__ */React12.createElement(Viewport3, null, /* @__PURE__ */React12.createElement(ViewSmall3, null, (selectedPlace === null || selectedPlace === void 0 ? void 0 : selectedPlace.id) ? /* @__PURE__ */React12.createElement(FloatingPlaceCard, {
    data: createPlaceCardDetailsFragment(selectedPlace),
    size: PlaceCardSize.COMPACT,
    placeId: "".concat(selectedPlace.id),
    onClose: clearPlaceCardId
  }) : void 0), /* @__PURE__ */React12.createElement(ViewMedium3, null, (selectedPlace === null || selectedPlace === void 0 ? void 0 : selectedPlace.id) ? /* @__PURE__ */React12.createElement(FloatingPlaceCard, {
    data: createPlaceCardDetailsFragment(selectedPlace),
    size: PlaceCardSize.STANDARD,
    placeId: "".concat(selectedPlace.id),
    onClose: clearPlaceCardId
  }) : void 0))), /* @__PURE__ */React12.createElement(ExperimentControl, null)), children)) : null;
  var toolbar = showToolbar && mapToolbar ? /* @__PURE__ */React12.createElement(MapToolbar, {
    onClose: fullscreenOptions !== void 0 ? internalOnClose : void 0,
    data: mapToolbar,
    filterComponent: filterPlacement === "TOOLBAR" /* TOOLBAR */ && filterComponent
  }) : null;
  if (fullscreenOptions) {
    return /* @__PURE__ */React12.createElement(EGDSSheet, {
      isVisible: fullscreenOptions.isDialogOpen,
      type: "full",
      triggerRef: fullscreenOptions.triggerRef
    }, toolbar, content);
  }
  return content;
};
DynamicSearchMap.displayName = "sharedui-DynamicSearchMap";
// src/components/property-search-map-trigger/property-search-map-trigger.tsx
import React13 from "react";
import { gql as gql12, useQuery as useQuery3 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { fullscreenOptionsCloseMapDialogPropBuilder, MapTrigger } from "@shared-ui/lodging-fragments";
var __Query2 = gql12(_templateObject12(), MapTrigger.fragment);
var PropertySearchMapTrigger = function (props) {
  var inputs = props.inputs,
    children = props.children,
    className = props.className,
    _props_dialogId = props.dialogId,
    dialogId = _props_dialogId === void 0 ? "map" : _props_dialogId,
    _props_dialogQueryKey = props.dialogQueryKey,
    dialogQueryKey = _props_dialogQueryKey === void 0 ? "pwaOverlay" : _props_dialogQueryKey,
    dialogView = props.dialogView,
    batchKey = props.batchKey,
    externalData = props.externalData,
    staticTrigger = props.staticTrigger;
  var context = useBexApi3().context;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var shouldSkipPropertySearchMapDialogTriggerQuery = Boolean(externalData);
  var _useQuery3 = useQuery3(__Query2, {
      context: {
        batchKey: batchKey
      },
      variables: variables,
      skip: shouldSkipPropertySearchMapDialogTriggerQuery
    }),
    data = _useQuery3.data,
    loading = _useQuery3.loading,
    previousData = _useQuery3.previousData,
    error = _useQuery3.error;
  var _data_propertySearch_mapTrigger;
  var mapTriggerData = loading ? previousData === null || previousData === void 0 ? void 0 : previousData.propertySearch.mapTrigger : (_data_propertySearch_mapTrigger = data === null || data === void 0 ? void 0 : data.propertySearch.mapTrigger) !== null && _data_propertySearch_mapTrigger !== void 0 ? _data_propertySearch_mapTrigger : externalData;
  if (error || !mapTriggerData) {
    return null;
  }
  return /* @__PURE__ */React13.createElement(MapTrigger, {
    data: mapTriggerData,
    className: className,
    dialogId: dialogId,
    dialogQueryKey: dialogQueryKey,
    dialogView: dialogView,
    closeMapDialogPropBuilder: fullscreenOptionsCloseMapDialogPropBuilder,
    staticTrigger: staticTrigger
  }, children);
};
PropertySearchMapTrigger.displayName = "sharedui-PropertySearchMapTrigger";
export { DatedSearches, DynamicSearchMap, PropertySearchMapTrigger };